export default __webpack_public_path__ + "static/media/家庭寄养勋章.31b33b29.png";